export const formatNumber = (value, {
  minimumFractionDigits = 0,
  maximumFractionDigits = 1,
  ...options
} = {}) => {
  return Number(value).toLocaleString('pt-BR', {
    ...options,
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export function formatSocialNumberWithDecimal(rawNumber) {
  const thousand = 1000;
  const million = 1000000;

  if (rawNumber >= thousand && rawNumber < million) {
    return `${formatNumber(rawNumber / thousand)}k`;
  }

  if (rawNumber >= million) {
    return `${formatNumber(rawNumber / million)}M`;
  }
  return formatNumber(rawNumber);
}

export function removeHTMLTagsFromText(string) {
  return string.replace(/(<([^>]+)>)/gu, '');
}

export function removeSeparator(label) {
  return /(-+)/u.test(label) ? label.replace(/(.+-+)/gu, '') : label;
}

export function splitStringOnSeparator(string, separator) {
  if (!separator) {
    return string;
  }

  return string.split(separator)
    .filter(str => str.trim().length > 0);
}

export function stringDateToTimestamp(stringDate) {
  const [day, month, year] = stringDate.split('/');
  return new Date(year, month - 1, day).getTime();
}

export function secondsToTime(totalSeconds) {
  let seconds = Math.floor(totalSeconds);
  const hoursTotal = Math.floor(seconds / 3600);
  const days = Math.floor(hoursTotal / 24);
  const hours = Math.floor(hoursTotal % 24);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  seconds %= 60;
  return days >= 1
    ? `${days}d ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
    : `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function timeToSeconds(time) {
  if (time === '00:00:00' || time === undefined) return 0;

  const [days, newTime] = time.includes(' ')
    ? time.replace(/\.\d+$/u, '').split(' ')
    : [0, time.replace(/\.\d+$/u, '')];

  const [hours, minutes, seconds] = (newTime || time).split(':').map(Number);

  return (parseInt(days, 10) * 86400) + (hours * 3600) + (minutes * 60) + (seconds || 0);
}

export function formatBlipHour(time) {
  const formattedTime = time.replace(/\.\d+$/u, '');

  if (formattedTime.includes('.')) {
    const [days, rest] = formattedTime.split('.');
    const [hours, minutes] = rest.split(':');
    return `${days}d ${hours}:${minutes}`;
  }
  return formattedTime;
}

export function remapFieldKeys(map, data) {
  const mapIntoNewObject = (map, origin) =>
    Object.fromEntries(
      Object.entries(map).map(([key, value]) => [value, origin[key]])
    );
  return data.map(item => mapIntoNewObject(map, item));
}
